import {NgIf} from '@angular/common';
import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import {TranslateService, TranslateModule} from '@ngx-translate/core';
import {
  DialogCloseButtonComponent,
  InfoMessageComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent
} from '@q9elements/ui-kit/components';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    MatDialogModule,
    TranslateModule,
    DialogCloseButtonComponent,
    InfoMessageComponent,
    SecondaryButtonComponent,
    PrimaryButtonComponent
  ]
})
export class ConfirmDialogComponent {
  public title: string;
  public message: string;
  public warningMessage: string;
  public confirmButtonText: string;
  public processing = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private translateSvc: TranslateService,
    private dialogRef: MatDialogRef<ConfirmDialogType>
  ) {
    switch (data.type) {
      case ConfirmDialogType.SMART_REN:
        this.title = this.translateSvc.instant('RENUMBER_ACT.SMART');
        this.message = this.translateSvc.instant('RENUMBER_ACT.SMART_EXPLAIN');
        this.warningMessage = this.translateSvc.instant('POPUPS.NOT_UNDOABLE');
        this.confirmButtonText = this.translateSvc.instant('RENUMBER_ACT.SUBMIT');
        break;

      case ConfirmDialogType.FL_DIS:
        break;
    }
  }

  confirm() {
    if (this.processing) {
      return;
    }

    this.processing = true;
    this.dialogRef.disableClose = true;
    this.data.callbackOnConfirm(this.data.args).then(
      success => {
        if (success) {
          switch (this.data.type) {
            case ConfirmDialogType.SMART_REN: {
              const snackBarSuccessMessage =
                success + ' ' + this.translateSvc.instant('RENUMBER_ACT.SMART_SUCCESS');

              this.dialogRef.close(snackBarSuccessMessage);
              break;
            }
          }
        }
      },
      () => {
        this.dialogRef.disableClose = true;
        this.processing = false;
      }
    );
  }
}

export enum ConfirmDialogType {
  SMART_REN,
  FL_DIS
}
